"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericHttpError = exports.HttpError = exports.HttpStatusCode = void 0;
exports.isHttpSuccess = isHttpSuccess;
const serialization_1 = require("../serialization");
function isHttpSuccess(code) {
    return code >= 200 && code <= 299;
}
var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["Ok"] = 200] = "Ok";
    HttpStatusCode[HttpStatusCode["Created"] = 201] = "Created";
    HttpStatusCode[HttpStatusCode["Accepted"] = 202] = "Accepted";
    HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
    HttpStatusCode[HttpStatusCode["Found"] = 302] = "Found";
    HttpStatusCode[HttpStatusCode["NotModified"] = 304] = "NotModified";
    HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
    HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
    HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
    HttpStatusCode[HttpStatusCode["NotFound"] = 404] = "NotFound";
    HttpStatusCode[HttpStatusCode["UnsupportedMediaType"] = 406] = "UnsupportedMediaType";
    HttpStatusCode[HttpStatusCode["Conflict"] = 409] = "Conflict";
    HttpStatusCode[HttpStatusCode["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    HttpStatusCode[HttpStatusCode["ServerError"] = 500] = "ServerError";
    HttpStatusCode[HttpStatusCode["NotImplemented"] = 501] = "NotImplemented";
    HttpStatusCode[HttpStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpStatusCode[HttpStatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
    HttpStatusCode[HttpStatusCode["OriginIsUnreachable"] = 523] = "OriginIsUnreachable";
})(HttpStatusCode || (exports.HttpStatusCode = HttpStatusCode = {}));
class HttpError extends Error {
    constructor(status, type, title, detail = '') {
        super(`HTTP ${status} ${title}${detail ? ` (${typeof detail === 'string' ? detail : (0, serialization_1.jsonStringify)(detail)})` : ''}`);
        this.status = status;
        this.type = type;
        this.title = title;
        this.detail = detail;
    }
    toJSON() {
        const { status, title, detail, type } = this;
        return { status, title, detail, type };
    }
    toString() {
        return (0, serialization_1.jsonStringify)(this.toJSON());
    }
}
exports.HttpError = HttpError;
class GenericHttpError extends Error {
    constructor(status, body, headers) {
        super();
        this.status = status;
        this.body = body;
        this.headers = headers;
    }
}
exports.GenericHttpError = GenericHttpError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaHR0cEVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2h0dHAvaHR0cEVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUdBLHNDQUVDO0FBSkQsb0RBQWdEO0FBRWhELFNBQWdCLGFBQWEsQ0FBQyxJQUFZO0lBQ3RDLE9BQU8sSUFBSSxJQUFJLEdBQUcsSUFBSSxJQUFJLElBQUksR0FBRyxDQUFBO0FBQ3JDLENBQUM7QUFFRCxJQUFZLGNBbUJYO0FBbkJELFdBQVksY0FBYztJQUN0QixpREFBUSxDQUFBO0lBQ1IsMkRBQWEsQ0FBQTtJQUNiLDZEQUFjLENBQUE7SUFDZCwrREFBZSxDQUFBO0lBQ2YsdURBQVcsQ0FBQTtJQUNYLG1FQUFpQixDQUFBO0lBQ2pCLGlFQUFnQixDQUFBO0lBQ2hCLHFFQUFrQixDQUFBO0lBQ2xCLCtEQUFlLENBQUE7SUFDZiw2REFBYyxDQUFBO0lBQ2QscUZBQTBCLENBQUE7SUFDMUIsNkRBQWMsQ0FBQTtJQUNkLDJFQUFxQixDQUFBO0lBQ3JCLG1FQUFpQixDQUFBO0lBQ2pCLHlFQUFvQixDQUFBO0lBQ3BCLGlGQUF3QixDQUFBO0lBQ3hCLHlFQUFvQixDQUFBO0lBQ3BCLG1GQUF5QixDQUFBO0FBQzdCLENBQUMsRUFuQlcsY0FBYyw4QkFBZCxjQUFjLFFBbUJ6QjtBQUVELE1BQWEsU0FBVSxTQUFRLEtBQUs7SUFDaEMsWUFDVyxNQUFzQixFQUN0QixJQUFZLEVBQ1osS0FBYSxFQUNiLFNBQXNDLEVBQUU7UUFFL0MsS0FBSyxDQUNELFFBQVEsTUFBTSxJQUFJLEtBQUssR0FDbkIsTUFBTSxDQUFDLENBQUMsQ0FBQyxLQUFLLE9BQU8sTUFBTSxLQUFLLFFBQVEsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxJQUFBLDZCQUFhLEVBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFDbkYsRUFBRSxDQUNMLENBQUE7UUFUTSxXQUFNLEdBQU4sTUFBTSxDQUFnQjtRQUN0QixTQUFJLEdBQUosSUFBSSxDQUFRO1FBQ1osVUFBSyxHQUFMLEtBQUssQ0FBUTtRQUNiLFdBQU0sR0FBTixNQUFNLENBQWtDO0lBT25ELENBQUM7SUFFRCxNQUFNO1FBQ0YsTUFBTSxFQUFFLE1BQU0sRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLElBQUksRUFBRSxHQUFHLElBQUksQ0FBQTtRQUM1QyxPQUFPLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsSUFBSSxFQUFFLENBQUE7SUFDMUMsQ0FBQztJQUVELFFBQVE7UUFDSixPQUFPLElBQUEsNkJBQWEsRUFBQyxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUMsQ0FBQTtJQUN2QyxDQUFDO0NBQ0o7QUF0QkQsOEJBc0JDO0FBRUQsTUFBYSxnQkFBaUIsU0FBUSxLQUFLO0lBQ3ZDLFlBQ1csTUFBc0IsRUFDdEIsSUFBa0MsRUFDbEMsT0FBWTtRQUVuQixLQUFLLEVBQUUsQ0FBQTtRQUpBLFdBQU0sR0FBTixNQUFNLENBQWdCO1FBQ3RCLFNBQUksR0FBSixJQUFJLENBQThCO1FBQ2xDLFlBQU8sR0FBUCxPQUFPLENBQUs7SUFHdkIsQ0FBQztDQUNKO0FBUkQsNENBUUMifQ==